import axios from 'axios'
import api from '@/api'

export const settingsShopsModule = {
    namespaced: true,

    state:() => ({
        isLoading: true,
        shops: null,
    }),

    mutations: {
        setShops(state, data) {
            state.shops = data
        }
    },

    actions: {
        getShops({ state, commit }) {
            state.isLoading = true

            axios
            .get(`${api}projects/tcode/shops/`,
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                state.isLoading = false
                commit('setShops', response.data)
            })
            .catch((error) => {
                console.log(error);
                state.isLoading = false
            });
        },

        async saveChangesHandler({}, data) {
            return axios
            .patch(`${api}projects/tcode/shops/${data.id}/`,
            data.formData,
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                if(response.status == 200) {
                    return true
                } else {
                    return false
                }
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }
}